import React from 'react';
import { FileWarning, FileSpreadsheet, Send, Sparkles, CheckCircle2 } from 'lucide-react';

const PUBLISH_OPTIONS = [
  {
    action: 'draft',
    title: 'Save as Draft',
    subtitle: 'Stage for review. Live forms unchanged.',
    bullets: ['Records remain editable', 'Forms use last published version', 'Reviewers can comment'],
    Icon: FileWarning,
    PrimaryIcon: FileSpreadsheet,
    cta: 'Save as Draft',
    testId: 'save-draft-btn',
    border: 'border-amber-200',
    bg: 'bg-amber-50/40',
    hover: 'hover:border-amber-300',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-700',
    bullet: 'text-amber-600',
    btn: 'bg-amber-600 hover:bg-amber-700',
  },
  {
    action: 'submit-approval',
    title: 'Submit for Approval',
    subtitle: 'Reviewer (Legal) must approve before going Active.',
    bullets: ['Module status: Pending Approval', 'Live forms unchanged until approved', 'Audit-traceable workflow'],
    Icon: Send,
    PrimaryIcon: Send,
    cta: 'Submit for Approval',
    testId: 'submit-approval-btn',
    border: 'border-violet-200',
    bg: 'bg-violet-50/40',
    hover: 'hover:border-violet-300',
    iconBg: 'bg-violet-100',
    iconColor: 'text-violet-700',
    bullet: 'text-violet-600',
    btn: 'bg-violet-600 hover:bg-violet-700',
  },
  {
    action: 'publish',
    title: 'Publish Directly',
    badge: 'ADMIN',
    subtitle: 'Bypass approval. Activates schema immediately.',
    bullets: ['Forms render new schema immediately', 'Previous version archived', 'Override action — logged'],
    Icon: Sparkles,
    PrimaryIcon: CheckCircle2,
    cta: 'Publish New Version',
    testId: 'publish-version-btn',
    border: 'border-emerald-200',
    bg: 'bg-emerald-50/40',
    hover: 'hover:border-emerald-300',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-700',
    bullet: 'text-emerald-600',
    btn: 'bg-emerald-600 hover:bg-emerald-700',
  },
];

export default function PublishStep({ validation, onSave }) {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {PUBLISH_OPTIONS.map((opt) => {
          const { Icon, PrimaryIcon } = opt;
          return (
            <div key={opt.action} className={`p-5 rounded-xl border-2 ${opt.border} ${opt.bg} ${opt.hover} transition flex flex-col`}>
              <div className="flex items-start gap-3 mb-3">
                <div className={`w-10 h-10 rounded-lg ${opt.iconBg} flex items-center justify-center flex-shrink-0`}>
                  <Icon className={`w-5 h-5 ${opt.iconColor}`} />
                </div>
                <div>
                  <div className="text-sm font-bold text-slate-900">
                    {opt.title}
                    {opt.badge && <span className="text-[9px] font-bold text-emerald-700 ml-1">{opt.badge}</span>}
                  </div>
                  <div className="text-[11px] text-slate-600 mt-0.5">{opt.subtitle}</div>
                </div>
              </div>
              <ul className="space-y-1 mb-4 flex-1">
                {opt.bullets.map((t) => (
                  <li key={t} className="text-[11px] text-slate-700 flex items-start gap-1.5">
                    <span className={`${opt.bullet} font-bold`}>·</span>{t}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => onSave(opt.action)}
                className={`w-full inline-flex items-center justify-center gap-1.5 px-4 py-2 ${opt.btn} text-white text-xs font-semibold rounded-lg shadow-sm`}
                data-testid={opt.testId}
              >
                <PrimaryIcon className="w-3.5 h-3.5" />
                {opt.cta}
              </button>
            </div>
          );
        })}
      </div>

      <div className="mt-4 p-3 rounded-lg bg-slate-50 border border-slate-200 flex items-center gap-2 text-[11px] text-slate-700">
        <Sparkles className="w-3.5 h-3.5 text-[#CC0000] flex-shrink-0" />
        <span>{validation.objects.length} records ready · all three actions log an audit-trail entry in Version History.</span>
      </div>
    </div>
  );
}
